<script>
    import Fa from 'svelte-fa';
    import { faArrowLeft, faShare, faSearch, faUser } from '@fortawesome/pro-regular-svg-icons';
    import PredictiveSearch from '$lib/components/PredictiveSearch.svelte';

    import { page } from '$app/stores';
    import { browser } from '$app/environment';

    export let title = '';
    export let description = '';
    export let backButton = true;
    export let shareButton = false;
    export let userButton = false;
    export let homeButton = false;
    export let textCenter = false;
    export let searchButton = false;
    export let classes = '';

    let searchModalOpen = false;

    // Set welcome title to include customer first name
    if (title === 'Welcome') {
        if ($page.data.user.firstName) {
            title = `Welcome ${$page.data.user.firstName}`;
        } else {
            title = 'Caktus Vape';
        }
    }

    // Check if navigator.share is available
    const isShareAvailable = browser && navigator && 'share' in navigator ? true : false;
</script>

<div class={classes} class:lg:text-center={textCenter}>
    <div class="flex flex-row items-center gap-3">
        {#if homeButton}
            <a
                href="/"
                class="inline-flex h-9 w-9 flex-none items-center justify-center rounded-full bg-base-900 text-color-text shadow-md"
                aria-label="Go Home"
            >
                <img alt="Caktus Logo" src="/svg/CaktusEmblem.svg" width="150" height="150" class="block w-6 dark:invert" />
            </a>
        {/if}
        {#if backButton}
            <button
                class="inline-flex h-9 w-9 flex-none items-center justify-center rounded-full bg-base-900 text-color-text shadow-md"
                on:click={() => history.back()}
                aria-label="Go back button"
            >
                <Fa icon={faArrowLeft} size="1.1x" />
            </button>
        {/if}
        {#if title}
            <h1 class="ml-1 inline-flex grow text-lg font-semibold dark:text-purple-300">
                {title}
            </h1>
        {/if}
        {#if userButton}
            <a
                href="/account"
                class="inline-flex h-9 w-9 flex-none items-center justify-center rounded-full bg-base-900 text-color-text shadow-md"
                aria-label="Go Home"
            >
                <Fa icon={faUser} size="1.1x" />
            </a>
        {/if}
        {#if searchButton}
            {#if !searchModalOpen}
                <button
                    class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-base-900 text-color-text shadow-md"
                    on:click={() => (searchModalOpen = !searchModalOpen)}
                    aria-label="Open Search Interface"
                >
                    <Fa icon={faSearch} size="1x" />
                </button>
            {/if}
            <div class={`absolute z-40 text-color-text  ${searchModalOpen ? 'lg:relative lg:mr-5 lg:w-[420px]' : ''}`}>
                <PredictiveSearch bind:searchModalOpen />
            </div>
        {/if}
        {#if shareButton && isShareAvailable}
            <button
                class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-base-900 text-color-text shadow-md"
                on:click={() => {
                    navigator
                        .share({
                            title,
                            text: '',
                            url: $page.url
                        })
                        .catch((error) => {
                            if (error.name === 'AbortError') {
                                return void 0;
                            }
                        });
                }}
                aria-label="Share button"
            >
                <Fa icon={faShare} size="1x" />
            </button>
        {/if}
    </div>

    {#if description}
        <div class="m-auto mt-4 w-full max-w-sm basis-full pt-2 text-center text-sm text-color-text lg:max-w-lg lg:text-base" class:lg:m-auto={textCenter}>
            {description}
        </div>
    {/if}
</div>
